"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function now() {
    if (typeof window === 'undefined' || !('performance' in window)) {
        return Date.now();
    }
    return performance.now();
}
exports.default = now;
//# sourceMappingURL=now.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-compound-timer/build/lib/helpers/now.js
// module id = 1116
// module chunks = 0